<template>
  <b-row>
    <b-col sm="12">
      <my-card title="Daftar Komisi Mitra">
        <template slot="button">
          <button-add v-if="cP(45)" :to="{name: 'commissions-add'}" variant="primary"></button-add>
        </template>
        <template slot="body">
          <data-tables ref="datatables" endpoint="v1/payment_partner_commissions" :fields="fields">
            <template v-slot:3="{item}">
              {{item[3]}} %
            </template>
            <template v-slot:4="{item}">
              <div class="float-none">
                <button-link v-if="cP(46)" size="sm" :to="{name:'commissions-edit',params:{id: item[4]}}" feather-icon="EditIcon"></button-link>
                <button-delete v-if="cP(47)" @ondelete="deleteRow" :id="item[4]" :name="`${item[0]} (${item[1]})`"></button-delete>
              </div>
            </template>
          </data-tables>
        </template>
      </my-card>
    </b-col>
  </b-row>
</template>

<script>
import ButtonAdd from '@/my-components/ButtonAdd.vue'
import DataTables from '@/my-components/DataTables.vue'
import ButtonDelete from '@/my-components/ButtonDelete.vue'
import ButtonLink from '@/my-components/ButtonLink.vue'

export default {
  components:{
    ButtonAdd,
    DataTables,
    ButtonDelete,
    ButtonLink,
  },
  data() {
    return {
      fields: {
        0:{sortable: true, searchable: true, label:'Nama'},
        1:{sortable: true, searchable: true, label:'Mitra'},
        2:{sortable: true, searchable: true, label:'Keterangan'},
        3:{sortable: true, searchable: true, label:'Persentase'},
        4:{sortable: false, searchable: false, label:''},
      }
    }
  },
  methods:{
    async deleteRow(payload){
      try {
        await this.$store.dispatch('commissions/destroy',payload)
        this.$refs.datatables.refresh()
        this.toastSuccess("OK","Data Berhasil Dihapus!")
      } catch (error) {
        this.handleError(error)
      }
    }
  }
}
</script>

<style>

</style>